import { render, staticRenderFns } from "./UpdateRmStockPopUp.vue?vue&type=template&id=d506ed74&scoped=true&"
import script from "./UpdateRmStockPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateRmStockPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRmStockPopUp.vue?vue&type=style&index=0&id=d506ed74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d506ed74",
  null
  
)

export default component.exports